import React from 'react';
//
import { Header, Icon, Label, Placeholder, Popup } from 'semantic-ui-react';
//
import styles from '../LeftToolbarStyle';
import { isEmpty } from '../../../../commons/utils';
// eslint-disable-next-line import/named
import { labelTextConfig } from '../../config';

const CustomPlaceholder = () => (
	<Placeholder style={{ ...styles.textNoWrap }}>
		<Placeholder.Header>
			<Placeholder.Line />
		</Placeholder.Header>
	</Placeholder>
);

const SpanList = ({ textVal }) => {
	if (Array.isArray(textVal)) {
		return textVal.map((tv, idx) => <span key={idx.toString()}>{tv}</span>);
	}
	return <span>{textVal}</span>;
};

const NoData = () => <Header textAlign="center">No Publication Selected</Header>;

const CreateLabelText = ({ selection, usePlaceholder }) => {
	if (isEmpty(selection)) return <NoData />;
	//
	const labelConfigKeys = Object.keys(labelTextConfig);
	const selectKeys = Object.keys(selection);
	return labelConfigKeys
		.filter((k) => selectKeys.includes(k))
		.map(
			(v, i) =>
				labelTextConfig[v]?.public && (
					<Header
						key={i.toString()}
						as={(labelTextConfig[v] && labelTextConfig[v].headerSize) || labelTextConfig.default.headerSize}
						style={{ order: labelTextConfig[v].order, ...styles.header }}
					>
						<Label
							as="a"
							style={{ ...styles.headerLabel, ...styles.textNoWrap }}
							color={labelTextConfig[v].color}
						>
							<Icon
								name={(labelTextConfig[v] && labelTextConfig[v].iconName) || ''}
								// content={(labelTextConfig[v] && labelTextConfig[v].labelText) || ''}
							/>
							{(labelTextConfig[v] && labelTextConfig[v].labelText) || ''}
						</Label>
						<br />
						{/* 若是波斯語，則文字方向由又到左 */}

						<div style={{ ...styles.headerTextLine }}>
							{(usePlaceholder && <CustomPlaceholder />) || (
								<div
									style={{
										...styles.headerTextLineSpanBox,
									}}
								>
									<Popup
										content={selection[v] || ''}
										trigger={
											<span
												style={{ ...styles.textNoWrap }}
												dir={labelTextConfig[v].dir ? labelTextConfig[v].dir : 'default'}
											>
												<SpanList textVal={selection[v] || ''} />
											</span>
										}
									/>
								</div>
							)}
						</div>
					</Header>
				)
		);
};

const DataTool = ({ selection, usePlaceholder }) => (
	<CreateLabelText selection={selection} usePlaceholder={usePlaceholder} />
);

export default DataTool;
